import type { AuthUser, UserConfig } from '@/types/auth';

const isValidUserConfig = (config: unknown): config is UserConfig => {
  if (!config || typeof config !== 'object') return false;
  const c = config as Record<string, unknown>;
  return (
    typeof c.subscription_type === 'string' &&
    typeof c.expiration_timestamp === 'number' &&
    typeof c.customer_id === 'string'
  );
};

export const adaptUserToAuthUser = (
  user: {
    idToken: { jwtToken: string; payload: { name: string; [key: string]: unknown } };
    config?: unknown;
    [key: string]: unknown;
  } | null,
): AuthUser | null => {
  if (!user) return null;

  const config: UserConfig | undefined = isValidUserConfig(user.config) ? user.config : undefined;

  const { config: _unusedConfig, ...userWithoutConfig } = user;

  return {
    ...userWithoutConfig,
    idToken: {
      jwtToken: user.idToken.jwtToken,
    },
    config,
  };
};

export const createSetIsLoggedInAdapter = (
  setUser: (
    user: {
      idToken: { jwtToken: string; payload: { name: string; [key: string]: unknown } };
      config?: unknown;
      [key: string]: unknown;
    } | null,
  ) => void,
): ((user: AuthUser | null) => void) => {
  return (authUser: AuthUser | null) => {
    if (!authUser) {
      setUser(null);
      return;
    }

    const user = {
      ...authUser,
      idToken: {
        jwtToken: authUser.idToken.jwtToken,
        payload: {
          name: (authUser as { idToken?: { payload?: { name?: string } } }).idToken?.payload?.name || '',
          ...((authUser as { idToken?: { payload?: Record<string, unknown> } }).idToken?.payload || {}),
        },
      },
      config: authUser.config,
    };

    setUser(user);
  };
};
